export default "__VITE_ASSET__BzC0zCAk__"